/* eslint-disable no-undef */

import React, { Component } from 'react'
import { withStyles } from '@material-ui/core/styles/index'

const styles = theme => ({
    root: {
        marginBottom: 4,
        textAlign: 'center',
        fontSize: '0.8rem',
        textDecoration: 'none',
        //textTransform: 'uppercase',
        //letterSpacing: 0.5,
        color: theme.termsColor ? theme.termsColor + '!important' : 'rgba(0,0,0,0.41)!important',
        width: '100%',
        marginTop: -1,
        ...(theme.isMobile && {})
    },
    link: {
        color: theme.termsColor ? theme.termsColor + '!important' : 'rgba(0,0,0,0.41)!important',
        textDecoration: 'none'
    }
})

class Terms extends Component {
    state = {}

    render() {
        const { classes, theme } = this.props
        if (!theme?.termsUrl) {
            return null
        }
        return (
            <div className={classes.root + ' Terms'}>
                <a href={theme?.termsUrl ? theme?.termsUrl : 'https://www.rahoo.fi/tietosuoja/'} className={classes.link} target="blank">
                    {theme?.termsTitle ? theme?.termsTitle : 'Palvelun käyttöehdot ja tietosuojakäytännöt'}
                </a>
            </div>
        )
    }
}

export default withStyles(styles)(Terms)
